import { Image } from '@mantine/core';
import { INTEGRATION_LOGO_BASE_PATH } from '@/utils/constants.ts';
import AppIcon from '@/components/AppIcon.tsx';
import { HiOutlineEnvelope, HiOutlinePhone, HiOutlinePrinter, HiRss } from 'react-icons/hi2';
import { LuWebhook } from 'react-icons/lu';

type IntegrationLogoProps = {
  name: string;
  size?: string;
  useBorderRadius?: boolean;
};

const IntegrationLogo = ({ name, size = '18px', useBorderRadius = true }: IntegrationLogoProps) => {
  if (name === 'email') {
    return <AppIcon Icon={HiOutlineEnvelope} size={size} />;
  } else if (name === 'phone') {
    return <AppIcon Icon={HiOutlinePhone} size={size} />;
  } else if (name === 'fax') {
    return <AppIcon Icon={HiOutlinePrinter} size={size} />;
  } else if (name === 'webhook') {
    return <AppIcon Icon={LuWebhook} size={size} />;
  } else if (name === 'http-request') {
    return <AppIcon Icon={HiRss} size={size} />;
  }
  const logoURL = `${INTEGRATION_LOGO_BASE_PATH}${name.toLowerCase().replace('-', '_')}.svg`;
  return (
    <Image
      radius={useBorderRadius ? 'md' : undefined}
      src={logoURL}
      height={size}
      fit={'contain'}
      w={'unset'}
    />
  );
};

export default IntegrationLogo;
